export default __webpack_public_path__ + "static/af-a969764df4270be072ddc98b590cb479.svg";